import { render } from "./Lifeexpectancy.vue?vue&type=template&id=337f59d2&scoped=true"
import script from "./Lifeexpectancy.vue?vue&type=script&lang=js"
export * from "./Lifeexpectancy.vue?vue&type=script&lang=js"

import "./Lifeexpectancy.vue?vue&type=style&index=0&id=337f59d2&scoped=true&lang=css"

import exportComponent from "/Users/alexisbailly/Documents/Programming/Website/vueform/Wealth & Retirement/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-337f59d2"]])

export default __exports__